"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rebuildProjectionOutputDtoSchema = exports.rebuildFindingProjectionInputDtoSchema = exports.rebuildAssertionResultProjectionInputDtoSchema = void 0;
const zod_1 = require("zod");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const enum_names_js_1 = require("./enum-names.js");
exports.rebuildAssertionResultProjectionInputDtoSchema = zod_1.z.object({
    assertionResultId: zod_1.z.string(),
});
exports.rebuildFindingProjectionInputDtoSchema = zod_1.z.object({
    findingId: zod_1.z.string(),
});
exports.rebuildProjectionOutputDtoSchema = zod_1.z.object({
    severity: sigma_engine_shared_1.RequirementsV2.RequirementSeveritySchema,
    severityName: enum_names_js_1.requirementSeverityNameSchema.describe('Name of the numeric `severity`, e.g. `Warning`.'),
    workflowState: sigma_engine_shared_1.RequirementsV2.RequirementWorkflowStateSchema,
    workflowStateName: enum_names_js_1.requirementWorkflowStateNameSchema.describe('Name of the numeric `workflowState`, e.g. `Unreviewed`.'),
    message: zod_1.z.string().nullable(),
    description: zod_1.z.string().nullable(),
    latestLogEntryId: zod_1.z.string().nullable(),
    latestLogEntryAt: zod_1.z.date().nullable(),
});
//# sourceMappingURL=admin.dto.js.map